(function () {
    'use strict';

    angular
        .module('franchiser.directives')
        .directive('personUnitAssociation', PersonUnitAssociation)

    /** @ngInject */
    function PersonUnitAssociation($q, HelperService, ResponsabilityService, AccessLevelService, AuthenticationService, PATHS_FRANCHISER, DEFAULT_IDENTIFIERS) {
        function PersonUnitAssociationController() {
            const vm = this;

            vm.initPersonUnitVars = (index, personUnit) => {
                vm.personUnitAssociationData[index] = {
                    UnitId: personUnit.UnitId,
                    AccessLevelId: null,
                    ResponsibilityId: null
                }
            }

            vm.searchUnitInFoundPerson = unitId => {
                if (!vm.foundPerson)
                    return false;

                return vm.foundPerson.Person_Unit.find(personUnit => (personUnit.UnitId == unitId));
            }

            vm.getAllData = () => {
                HelperService.startLoading('.unit-permission-listing');

                $q.all([getResponsabilities(), getAccessLevels()])
                    .then(() => {
                        HelperService.stopLoading('.unit-permission-listing');
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.unit-permission-listing');
                    })
            }

            vm.isAccessLevelRequired = () => {
                let foundAnyUnit = vm.personUnitAssociationData.find(personUnit => (personUnit.AccessLevelId != null));

                return foundAnyUnit == undefined;
            }

            vm.isResponsabilityRequired = () => {
                let foundAnyUnit = vm.personUnitAssociationData.find(personUnit => (personUnit.ResponsibilityId != null));

                return foundAnyUnit == undefined;
            }

            vm.canEditAccessLevel = () => {
                return vm.loggedUserData.AccessLevelId == DEFAULT_IDENTIFIERS.ACCESS_LEVEL_FRANCHISER_ADMINISTRATOR && !vm.isEditingFranchiseeUnit;
            }

            init();

            function getResponsabilities() {
                return ResponsabilityService
                    .getAll()
                    .then(success => {
                        if (vm.isEditingFranchiseeUnit) {
                            vm.responsabilities = success.filter(resp => (resp.Id == 4));
                        } else {
                            vm.responsabilities = success.filter(resp => (resp.Id != 4));
                        }
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.unit-permission-listing');
                    })
            }

            function getAccessLevels() {
                return AccessLevelService
                    .getAll()
                    .then(success => {
                        vm.accessLevels = vm.isPreRegister ? success : success.filter(accessLevel => (accessLevel.Id == 1 || accessLevel.Id == 2));
                    }, error => {
                        HelperService.errorCallback(error);
                        HelperService.stopLoading('.custom-filters');
                    })
            }

            function init() {
                vm.loggedUserData = AuthenticationService.getSelectedData();
            }
        }

        function link(scope, element, attrs, ctrl) {
            ctrl.getAllData();
        }

        return {
            bindToController: true,
            controller: PersonUnitAssociationController,
            controllerAs: 'vm',
            link: link,
            restrict: 'AE',
            templateUrl: `${PATHS_FRANCHISER.PHYSICAL}/directives/person-unit-association/person-unit-association.html`,
            scope: {
                loggedPersonAvailableUnits: '=',
                foundPerson: '=',
                personUnitAssociationData: '=',
                isEditingFranchiseeUnit: '=',
                isPreRegister: '='
            }
        }
    }
}());